import apiClient from './client';
import { unwrapAndTransform, unwrapPaginatedResponse } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All unwrapping now handled by unwrapAndTransform / unwrapPaginatedResponse
// Eliminates: manual response.data.data unwrapping patterns (4 occurrences)
// ---------------------------------------------------------------------------
export const userApi = {
    async getUsers(filters = {}) {
        const params = new URLSearchParams();
        if (filters.status)
            params.append('status', filters.status);
        if (filters.role)
            params.append('role', filters.role);
        if (filters.search)
            params.append('search', filters.search);
        if (filters.page)
            params.append('page', filters.page.toString());
        if (filters.perPage)
            params.append('perPage', filters.perPage.toString());
        if (filters.sortBy)
            params.append('sortBy', filters.sortBy);
        if (filters.sortOrder)
            params.append('sortOrder', filters.sortOrder);
        const response = await apiClient.get(`/v1/admin/users?${params.toString()}`);
        // Use unwrapPaginatedResponse to handle nested structure
        const { data, pagination } = unwrapPaginatedResponse(response, {
            transformData: true
        });
        return {
            users: data,
            total: pagination.total,
            page: pagination.page,
            perPage: pagination.limit,
        };
    },
    async getUser(userId) {
        const response = await apiClient.get(`/v1/admin/users/${userId}`);
        return unwrapAndTransform(response);
    },
    async updateUserStatus(userId, data) {
        const response = await apiClient.patch(`/v1/admin/users/${userId}/status`, data);
        return unwrapAndTransform(response);
    },
    async deleteUser(userId) {
        await apiClient.delete(`/v1/admin/users/${userId}`);
    },
    async getUserStats() {
        const response = await apiClient.get('/v1/admin/users/stats');
        return unwrapAndTransform(response);
    },
};
